import { tv } from 'tailwind-variants';
import type { ParentProps } from 'solid-js';
import type { VariantProps } from 'tailwind-variants';

type Props = ParentProps<VariantProps<typeof tagStyles>>;

export function Tag(props: Props) {
	return <span class={tagStyles({ size: props.size, appearance: props.appearance })}>{props.children}</span>;
}

const tagStyles = tv({
	base: 'inline-flex flex-row gap-1 rounded-md py-1 text-nowrap',
	variants: {
		size: {
			sm: 'px-2 text-xs',
			md: 'px-2.5 text-sm',
			lg: 'px-3 text-base',
		},
		appearance: {
			success: 'bg-emerald-600 text-white',
			danger: 'bg-rose-600 text-white',
			warning: 'bg-yellow-600 text-white',
			info: 'bg-teal-600 text-white',
			neutral: 'bg-zinc-200 text-zinc-800',
		},
	},
	defaultVariants: {
		size: 'md',
		appearance: 'neutral',
	},
});
